var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AB35B111-E3C8-47B0-8431-C9C4E3C4D31D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-page-Full",
    transform: "translate(-261, -1264)",
    stroke: "#256BFD",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Audience-Copy",
    transform: "translate(24, 1189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Secret-Fans-Copy",
    transform: "translate(171, 43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/icons_24/Comments",
    transform: "translate(66, 32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3, 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,5.5 L9,5.5 M4,9 L12,9 M4,15 L4,17.3355 C4,17.8684 4,18.1348 4.10923,18.2716 C4.20422,18.3906 4.34827,18.4599 4.50054,18.4597004 C4.67563,18.4595 4.88367,18.2931 5.29976,17.9602 L7.6852,16.0518 C8.1725,15.662 8.4162,15.4671 8.6875,15.3285 C8.9282,15.2055 9.1844,15.1156 9.4492,15.0613 C9.7477,15 10.0597,15 10.6837,15 L13.2,15 C14.8802,15 15.7202,15 16.362,14.673 C16.9265,14.3854 17.3854,13.9265 17.673,13.362 C18,12.7202 18,11.8802 18,10.2 L18,4.8 C18,3.11984 18,2.27976 17.673,1.63803 C17.3854,1.07354 16.9265,0.6146 16.362,0.32698 C15.7202,0 14.8802,0 13.2,0 L4.8,0 C3.11984,0 2.27976,0 1.63803,0.32698 C1.07354,0.6146 0.6146,1.07354 0.32698,1.63803 C0,2.27976 0,3.11984 0,4.8 L0,11 C0,11.93 0,12.395 0.10222,12.7765 C0.37962,13.8117 1.18827,14.6204 2.22354,14.8978 C2.60504,15 3.07003,15 4,15 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.2b9d6ebe370b2c229f97d448e545bc6e.svg";
export { ForwardRef as ReactComponent };